import { z } from 'zod';
import { SaveAutomationTargetPayload } from '../models';
import { saveAutomationTargetPayloadSchema } from '../models/automationAssistant.schema';

export const saveAutomationTarget = (
  queueId: number,
  payload: SaveAutomationTargetPayload
) => {
  return {
    endpoint: `/queues/${queueId}/automation/targets`,
    method: 'POST',
    payloadSchema: saveAutomationTargetPayloadSchema,
    payload,
    responseSchema: z.unknown(),
  } as const;
};
